import { ArTranRow } from '@anduin/api';
import { ArTransactionRow } from './ar-transaction-row.model';

/** `ArTransactionRow` (queryable wire shape — `notes`/`paymentMethod`/`ppId`) → `ArTranRow` (legacy display shape — `note`/`paymentMethodType`/`ref`). */
export function mapQueryableResponseToArTranRow(raw: unknown): {
  data: ArTranRow[];
  totalRecords: number | undefined;
  nextCursor: string | null;
} {
  const envelope = raw as { data?: ArTransactionRow[]; totalRecords?: number; nextCursor?: string | null };
  const rows: ArTranRow[] = (envelope.data ?? []).map((r) => ({
    id: r.id,
    allocationStatus: r.allocationStatus as ArTranRow['allocationStatus'],
    transactionDate: r.transactionDate ?? '',
    clientId: r.clientId,
    clientRef: r.clientRef ?? '',
    clientName: r.clientName,
    typeDisplay: r.typeDisplay as ArTranRow['typeDisplay'],
    note: r.notes ?? '',
    // Null passes through; `formatMultiCurrency` renders it as empty so null and `0` stay visually distinct.
    debitAmount: r.debitAmount as number,
    creditAmount: r.creditAmount as number,
    paymentMethodType: r.paymentMethod ?? '',
    ref: r.ppId ?? '',
    depositDate: r.depositDate ?? '',
    status: r.status,
    isActive: r.isActive,
    amountRemaining: r.amountRemaining,
    invoiceNumber: r.invoiceNumber ?? undefined,
  }));
  return { data: rows, totalRecords: envelope.totalRecords, nextCursor: envelope.nextCursor ?? null };
}
